import {
  DOCUSIGN_INITIATE_START,
  DOCUSIGN_INITIATE_SUCCESS,
  DOCUSIGN_INITIATE_FAIL,
  DOCUSIGN_GET_ENVELOPE_START,
  DOCUSIGN_GET_ENVELOPE_SUCCESS,
  DOCUSIGN_GET_ENVELOPE_FAIL,
  DOCUSIGN_RESET,
} from '../../actionLabels/docusign';

const initialState = {
  // Loading flags
  isLoading: {
    initiate: false,
    getEnvelope: false,
  },

  // Signing data returned from POST /docusign/initiate
  // { envelopeId, signingUrl, documentName, status }
  signingData: null,

  // Latest fetched envelope status record
  envelope: null,

  error: null,
};

const docusignReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Initiate ────────────────────────────────────────────
    case DOCUSIGN_INITIATE_START:
      return { ...state, isLoading: { ...state.isLoading, initiate: true }, error: null, signingData: null };

    case DOCUSIGN_INITIATE_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, initiate: false },
        signingData: action.payload,
        error: null,
      };

    case DOCUSIGN_INITIATE_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, initiate: false },
        error: action.payload,
      };

    // ── Get Envelope ─────────────────────────────────────────
    case DOCUSIGN_GET_ENVELOPE_START:
      return { ...state, isLoading: { ...state.isLoading, getEnvelope: true }, error: null };

    case DOCUSIGN_GET_ENVELOPE_SUCCESS:
      return {
        ...state,
        isLoading: { ...state.isLoading, getEnvelope: false },
        envelope: action.payload,
        error: null,
      };

    case DOCUSIGN_GET_ENVELOPE_FAIL:
      return {
        ...state,
        isLoading: { ...state.isLoading, getEnvelope: false },
        error: action.payload,
      };

    // ── Reset ────────────────────────────────────────────────
    case DOCUSIGN_RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export default docusignReducer;
